import axios from 'axios'
import { GenericOrderBy } from '../../components/_EOS/Table'
import { Filter } from '../../components/_WMS/FilterComponent'
import { ApiConfig } from '../../config/api'
import {
  ProductOrigin,
  SelectedWarehousesByOperation
} from '../../interfaces/Producto/ProductOrigins'

const getProductsOrigins = (
  filter: Filter[],
  orderBy: GenericOrderBy<ProductOrigin>,
  page = 0,
  pageSize = 5
) => {
  const url = new URL(`${ApiConfig.ProductOriginApi}`)

  filter.forEach((el) => {
    url.searchParams.set(el.key, el.value)
  })

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

export interface ProductOriginOperationalPayload {
  name: string
  hasExpirationDays: boolean
  expirationDays?: number | null
  typeStorageId: number
  warehousesByOperation: SelectedWarehousesByOperation[]
  hasPriorityCourier: boolean
  hasPrioritySingleSku: boolean
  hasPriorityOverload: boolean
  overloadPercentage?: number | null
}

const patchProductOriginOperational = (
  productOriginId: number,
  data: ProductOriginOperationalPayload
) => {
  return axios.patch(
    `${ApiConfig.ProductOriginApi}/OperationalUpdate/${productOriginId}`,
    data
  )
}

const getTypeOperationWarehouse = (
  typeStorageId: number,
  productOriginId?: number
) => {
  const url = new URL(
    `${ApiConfig.TypeOperationApi}/${typeStorageId}/Warehouse`
  )

  if (productOriginId)
    url.searchParams.set('producOriginId', productOriginId.toString())

  return axios.get(url.toString())
}

export {
  getProductsOrigins,
  patchProductOriginOperational,
  getTypeOperationWarehouse
}
